import React, { useRef, useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/ImageSliderComponent.css';
import useMediaQuery from '@mui/material/useMediaQuery';

const ImageSliderComponent = (props) => {
  const isMobileView = useMediaQuery('(max-width:600px)');
  const [activeSlide, setActiveSlide] = useState(0);

  const handleContextMenu = (e) => e.preventDefault();

  const slider1 = useRef(null);
  const slider2 = useRef(null);

  const [settingsFor, setSettingsFor] = useState(null);
  const [settingsNav, setSettingsNav] = useState(null);

  useEffect(() => {
    setSettingsFor({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      centerMode: false,
      asNavFor: slider2.current,
      beforeChange: (_, next) => setActiveSlide(next),
    });
    setSettingsNav({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: slider1.current,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      arrows: false,
    });
  }, [slider1, slider2]);

  const images = [
    { signedUrl: props.imageDisplayUrls[0].signedUrl },
    { signedUrl: props.imageDisplayUrls[0].imageWallUrls[0] },
    { signedUrl: props.imageDisplayUrls[0].imageWallUrls[1] },
  ];

  return (
    <div className="poster-slider">
      {/* Main image area */}
      <div className="poster-slider__main">
        <Slider {...settingsFor} ref={slider1}>
          {images.map((img, i) => (
            <div key={i}>
              <div className="poster-slider__image-wrap">
                <img
                  src={img.signedUrl}
                  alt={`Poster ${i + 1}`}
                  onContextMenu={handleContextMenu}
                  className="poster-slider__image"
                />
              </div>
            </div>
          ))}
        </Slider>

        {/* Arrows */}
        <button
          className="poster-slider__arrow poster-slider__arrow--prev"
          onClick={() => slider1.current?.slickPrev()}
          aria-label="Föregående"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button
          className="poster-slider__arrow poster-slider__arrow--next"
          onClick={() => slider1.current?.slickNext()}
          aria-label="Nästa"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>

      {/* Thumbnails */}
      <div className="poster-slider__thumbs">
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => slider1.current?.slickGoTo(i)}
            className={`poster-slider__thumb${activeSlide === i ? ' poster-slider__thumb--active' : ''}`}
          >
            <img src={img.signedUrl} alt={`Miniatyr ${i + 1}`} onContextMenu={handleContextMenu} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ImageSliderComponent;
